import React from "react";
import { useTranslation } from "react-i18next";
import { TextField } from "@mui/material";

import {
  ASSESSMENT_NAME_MAX_LENGTH,
  ASSESSMENT_NOTES_MAX_LENGTH,
} from "../constants";

/**
 * Optional Name + Notes inputs, shared by the assessment creation forms (risks
 * map & municipality risks map) and the history edit dialog. Both fields are
 * capped and show a live character counter.
 */
function AssessmentMetaFields({
  name,
  notes,
  onNameChange,
  onNotesChange,
  disabled,
}) {
  const { t } = useTranslation();

  return (
    <>
      <TextField
        label={`${t("forms.name")} (${t("common.optional")})`}
        variant="outlined"
        fullWidth
        size="small"
        value={name}
        onChange={(e) => onNameChange(e.target.value)}
        disabled={disabled}
        inputProps={{ maxLength: ASSESSMENT_NAME_MAX_LENGTH }}
        helperText={`${name?.length ?? 0}/${ASSESSMENT_NAME_MAX_LENGTH}`}
        FormHelperTextProps={{ sx: { textAlign: "right", m: 0, mt: 0.25 } }}
      />
      <TextField
        label={`${t("forms.notes")} (${t("common.optional")})`}
        variant="outlined"
        fullWidth
        size="small"
        multiline
        minRows={3}
        value={notes}
        onChange={(e) => onNotesChange(e.target.value)}
        disabled={disabled}
        inputProps={{ maxLength: ASSESSMENT_NOTES_MAX_LENGTH }}
        helperText={`${notes?.length ?? 0}/${ASSESSMENT_NOTES_MAX_LENGTH}`}
        FormHelperTextProps={{ sx: { textAlign: "right", m: 0, mt: 0.25 } }}
      />
    </>
  );
}

export default AssessmentMetaFields;
